__turbopack_context__.v({
  "loadingGradient": "Tgun1a_loadingGradient",
  "rotate-loading-gradient": "Tgun1a_rotate-loading-gradient",
});
